<template>
    <div id="filters-modal" tabindex="-1" aria-hidden="true"
        class="fixed top-0 left-0 right-0 z-50 p-4 overflow-x-hidden hidden overflow-y-auto md:inset-0 h-[100vh] max-h-full animate-in fade-in max-w-[100vw] backdrop-blur-sm">
        <div class="absolute right-0 top-0 w-full max-w-md h-full">
            <div
                class="relative bg-primary rounded-l-lg shadow-3xl h-full overflow-y-scroll overflow-x-visible animate-in slide-in-from-right">
                <div
                    class="pointer-events-none cursor-pointer fixed bg-primary font-bold rounded-t-lg px-8 flex justify-center items-center -rotate-90 text-white h-12 right-[390px] top-20">
                    <span>{{ $t('Close') }}</span>
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 ml-4" fill="currentColor"
                        viewBox="0 0 512 512"><!--! Font Awesome Free 6.4.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. -->
                        <path
                            d="M233.4 406.6c12.5 12.5 32.8 12.5 45.3 0l192-192c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L256 338.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l192 192z" />
                    </svg>
                </div>
                <div class="p-6">


                    <div @click="showFiltered()"
                        class="text-center bg-white bg-opacity-10 border border-white text-white py-4 mb-4 rounded cursor-pointer hover:scale-95 transition duration-300 shadow-xl">
                        {{ $t("Show results") }}
                    </div>

                    <!-- <app-accordion class="rounded bg-white  px-4 py-6 mb-4" :open="true">
                        <template v-slot:title>
                            {{ $t('Price per night') }}:
                        </template>
                        <template v-slot:content>
                            <div class="text-sm mt-4 flex flex-wrap" ref="insideblock">
                                <HistogramSlider :width="358" :bar-height="100" :data="data" :drag-interval="true"
                                    :colors="[$third_color, $main_color]" :force-edges="true" :min="60" :max="500"
                                    :prettify="prettify" :primaryColor="$main_color" labelColor="#292929" />
                            </div>
                        </template>
                    </app-accordion> -->

                    <!-- <app-accordion class="rounded bg-white  px-4 py-6 mb-4" :open="true">
                        <template v-slot:title>
                            {{ $t('Bedrooms') }}:
                        </template>
                        <template v-slot:content>
                            <div class="flex flex-col space-y-2 p-2">
                                <input type="range" class="w-full accent-primary" min="1" max="6" step="1" />
                                <ul class="flex justify-between w-full px-[10px] h-6 text-sm">
                                    <li class="flex justify-center relative"><span class="absolute">1</span></li>
                                    <li class="flex justify-center relative"><span class="absolute">2</span></li>
                                    <li class="flex justify-center relative"><span class="absolute">3</span></li>
                                    <li class="flex justify-center relative"><span class="absolute">4</span></li>
                                    <li class="flex justify-center relative"><span class="absolute">5</span></li>
                                    <li class="flex justify-center relative"><span class="absolute">6+</span></li>
                                </ul>
                            </div>
                        </template>
                    </app-accordion> -->

                    <app-accordion class="text-white py-6 mb-4" :open="true">
                        <template v-slot:title>
                            {{ $t('Pets') }}:
                        </template>
                        <template v-slot:content>
                            <div class="text-sm mt-4 flex flex-wrap">
                                <div class="flex items-center w-1/2 pr-2">
                                    <input type="checkbox" name="filter_pets_allowed" id="filter_pets_allowed"
                                        v-model="form['pets']['PETS_CONSIDERED']" ref="filter_pets_allowed"
                                        class="hidden peer">
                                    <label for="filter_pets_allowed"
                                        class="h-full inline-flex py-4 items-center flex-col w-full text-white bg-primary border border-dashed border-white rounded-lg cursor-pointer peer-checked peer-checked:border-white peer-checked:bg-white peer-checked:text-primary hover:bg-white hover:bg-opacity-20 transition duration-300">
                                        <div class="sr-only">{{ $t('Pets allowed') }}</div>
                                        <div>
                                            <svg xmlns="http://www.w3.org/2000/svg" class="h-12 w-12" fill="currentColor"
                                                viewBox="0 0 512 512"><!--! Font Awesome Free 6.4.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. -->
                                                <path
                                                    d="M226.5 92.9c14.3 42.9-.3 86.2-32.6 96.8s-70.1-15.6-84.4-58.5s.3-86.2 32.6-96.8s70.1 15.6 84.4 58.5zM100.4 198.6c18.9 32.4 14.3 70.1-10.2 84.1s-59.7-.9-78.5-33.3S-2.7 179.3 21.8 165.3s59.7 .9 78.5 33.3zM69.2 401.2C121.6 259.9 214.7 224 256 224s134.4 35.9 186.8 177.2c3.6 9.7 5.2 20.1 5.2 30.5v1.6c0 25.8-20.9 46.7-46.7 46.7c-11.5 0-22.9-1.4-34-4.2l-88-22c-15.3-3.8-31.3-3.8-46.6 0l-88 22c-11.1 2.8-22.5 4.2-34 4.2C84.9 480 64 459.1 64 433.3v-1.6c0-10.4 1.6-20.8 5.2-30.5zM421.8 282.7c-24.5-14-29.1-51.7-10.2-84.1s54-47.3 78.5-33.3s29.1 51.7 10.2 84.1s-54 47.3-78.5 33.3zM310.1 189.7c-32.3-10.6-46.9-53.9-32.6-96.8s52.1-69.1 84.4-58.5s46.9 53.9 32.6 96.8s-52.1 69.1-84.4 58.5z" />
                                            </svg>
                                        </div>
                                    </label>
                                </div>
                                <div class="flex items-center w-1/2 pl-2">
                                    <input type="checkbox" name="filter_pets_allowed" id="filter_pets_not_allowed"
                                        v-model="form['pets']['PETS_NOT_ALLOWED']" ref="filter_pets_not_allowed"
                                        class="hidden peer">
                                    <label for="filter_pets_not_allowed"
                                        class="h-full inline-flex py-4 items-center flex-col w-full text-white bg-primary border border-dashed border-white rounded-lg cursor-pointer peer-checked peer-checked:border-white peer-checked:bg-white peer-checked:text-primary hover:bg-white hover:bg-opacity-20 transition duration-300">
                                        <div class="sr-only">{{ $t('Pets not allowed') }}</div>
                                        <div class="flex justify-center items-center h-full w-full">
                                            <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 absolute"
                                                fill="currentColor"
                                                viewBox="0 0 512 512"><!--! Font Awesome Free 6.4.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. -->
                                                <path
                                                    d="M226.5 92.9c14.3 42.9-.3 86.2-32.6 96.8s-70.1-15.6-84.4-58.5s.3-86.2 32.6-96.8s70.1 15.6 84.4 58.5zM100.4 198.6c18.9 32.4 14.3 70.1-10.2 84.1s-59.7-.9-78.5-33.3S-2.7 179.3 21.8 165.3s59.7 .9 78.5 33.3zM69.2 401.2C121.6 259.9 214.7 224 256 224s134.4 35.9 186.8 177.2c3.6 9.7 5.2 20.1 5.2 30.5v1.6c0 25.8-20.9 46.7-46.7 46.7c-11.5 0-22.9-1.4-34-4.2l-88-22c-15.3-3.8-31.3-3.8-46.6 0l-88 22c-11.1 2.8-22.5 4.2-34 4.2C84.9 480 64 459.1 64 433.3v-1.6c0-10.4 1.6-20.8 5.2-30.5zM421.8 282.7c-24.5-14-29.1-51.7-10.2-84.1s54-47.3 78.5-33.3s29.1 51.7 10.2 84.1s-54 47.3-78.5 33.3zM310.1 189.7c-32.3-10.6-46.9-53.9-32.6-96.8s52.1-69.1 84.4-58.5s46.9 53.9 32.6 96.8s-52.1 69.1-84.4 58.5z" />
                                            </svg>

                                            <svg xmlns="http://www.w3.org/2000/svg" class="h-14 w-14 absolute"
                                                fill="currentColor"
                                                viewBox="0 0 512 512"><!--! Font Awesome Free 6.4.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. -->
                                                <path
                                                    d="M367.2 412.5L99.5 144.8C77.1 176.1 64 214.5 64 256c0 106 86 192 192 192c41.5 0 79.9-13.1 111.2-35.5zm45.3-45.3C434.9 335.9 448 297.5 448 256c0-106-86-192-192-192c-41.5 0-79.9 13.1-111.2 35.5L412.5 367.2zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z" />
                                            </svg>
                                        </div>
                                    </label>
                                </div>
                            </div>
                        </template>
                    </app-accordion>

                    <app-accordion class="rounded bg-white  px-4 py-6 mb-4" :open="false">
                        <template v-slot:title>
                            {{ $t('Location') }}:
                        </template>
                        <template v-slot:content>
                            <div class="text-sm mt-4 flex flex-wrap">
                                <div class="flex items-center w-1/2 p-2" v-for="(item, $index) in filters.location"
                                    :key="$index">
                                    <input :id="'filter-location-' + $index" name="amenities[]" :value="$index"
                                        type="checkbox" v-model="form['location'][$index]"
                                        class="h-4 w-4 rounded border-gray-300 text-primary ring-primary focus:ring-primary">
                                    <label :for="'filter-location-' + $index" class="ml-3 min-w-0 flex-1 text-gray-500">
                                        {{ $t($index) }}
                                    </label>
                                </div>
                            </div>
                        </template>
                    </app-accordion>

                    <app-accordion class="rounded bg-white  px-4 py-6 mb-4" :open="false">
                        <template v-slot:title>
                            {{ $t('Features') }}:
                        </template>
                        <template v-slot:content>
                            <div class="text-sm mt-4 flex flex-wrap">
                                <div class="flex items-center w-1/2 p-2" v-for="(item, $index) in filters.amenities"
                                    :key="$index">
                                    <input :id="'filter-features-' + $index" name="amenities[]" :value="$index"
                                        type="checkbox" v-model="form['amenities'][$index]"
                                        class="h-4 w-4 rounded border-gray-300 text-primary ring-primary focus:ring-primary">
                                    <label :for="'filter-features-' + $index" class="ml-3 min-w-0 flex-1 text-gray-500">
                                        {{ $t($index) }}
                                    </label>
                                </div>
                            </div>
                        </template>
                    </app-accordion>

                    <app-accordion class="rounded bg-white  px-4 py-6 mb-4" :open="false">
                        <template v-slot:title>
                            {{ $t('Pool and wellness') }}:
                        </template>
                        <template v-slot:content>
                            <div class="text-sm mt-4 flex flex-wrap">
                                <div class="flex items-center w-1/2 p-2" v-for="(item, $index) in filters.pool"
                                    :key="$index">
                                    <input :id="'filter-pool-' + $index" name="amenities[]" :value="$index" type="checkbox"
                                        v-model="form['pool'][$index]"
                                        class="h-4 w-4 rounded border-gray-300 text-primary ring-primary focus:ring-primary">
                                    <label :for="'filter-pool-' + $index" class="ml-3 min-w-0 flex-1 text-gray-500">
                                        {{ $t($index) }}
                                    </label>
                                </div>
                            </div>
                        </template>
                    </app-accordion>

                    <app-accordion class="rounded bg-white  px-4 py-6 mb-4" :open="false">
                        <template v-slot:title>
                            {{ $t('Suitability') }}:
                        </template>
                        <template v-slot:content>
                            <div class="text-sm mt-4 flex flex-wrap">
                                <div class="flex items-center w-1/2 p-2" v-for="(item, $index) in filters.suitability"
                                    :key="$index">
                                    <input :id="'filter-suitability-' + $index" name="amenities[]" :value="$index"
                                        type="checkbox" v-model="form['suitability'][$index]"
                                        class="h-4 w-4 rounded border-gray-300 text-primary ring-primary focus:ring-primary">
                                    <label :for="'filter-suitability-' + $index"
                                        class="ml-3 min-w-0 flex-1 text-gray-500">
                                        {{ $t($index) }}
                                    </label>
                                </div>
                            </div>
                        </template>
                    </app-accordion>

                    <app-accordion class="rounded bg-white  px-4 py-6 mb-4" :open="false">
                        <template v-slot:title>
                            {{ $t('Accommodation type') }}:
                        </template>
                        <template v-slot:content>
                            <div class="text-sm mt-4 flex flex-wrap">
                                <div class="flex items-center w-1/2 p-2"
                                    v-for="(item, $index) in filters.accommodationTypes" :key="$index">
                                    <input :id="'filter-propertyType-' + $index" name="propertyType[]" :value="$index"
                                        type="checkbox" v-model="form['accommodationTypes'][$index]"
                                        class="h-4 w-4 rounded border-gray-300 text-primary ring-primary focus:ring-primary">
                                    <label :for="'filter-propertyType-' + $index" class="ml-3 min-w-0 flex-1 text-gray-500">
                                        {{ $t(item) }}
                                    </label>
                                </div>
                            </div>
                        </template>
                    </app-accordion>

                    <app-accordion class="rounded bg-white  px-4 py-6 mb-4" :open="false">
                        <template v-slot:title>
                            {{ $t('Services') }}:
                        </template>
                        <template v-slot:content>
                            <div class="text-sm mt-4 flex flex-wrap">
                                <div class="flex items-center w-1/2 p-2" v-for="(item, $index) in filters.services"
                                    :key="$index">
                                    <input :id="'filter-services-' + $index" name="amenities[]" :value="$index"
                                        type="checkbox" v-model="form['services'][$index]"
                                        class="h-4 w-4 rounded border-gray-300 text-primary ring-primary focus:ring-primary">
                                    <label :for="'filter-services-' + $index" class="ml-3 min-w-0 flex-1 text-gray-500">
                                        {{ $t($index) }}
                                    </label>
                                </div>
                            </div>
                        </template>
                    </app-accordion>

                </div>
            </div>
        </div>
    </div>
</template>


<script>

import moment from "moment";
import VueCookies from 'vue-cookies'

import filters from '../../data/filters.json'
import data from '../../data/data.json'

import HistogramSlider from 'vue-histogram-slider';
import 'vue-histogram-slider/dist/histogram-slider.css';

var selectedFilters = _.cloneDeep(filters);

for (const item in selectedFilters) {
    for (const value in selectedFilters[item]) {
        selectedFilters[item][value] = false;
    }
}

export default {
    name: 'filtermenu',
    props: ['visible'],
    components: {
        HistogramSlider
    },
    data() {
        return {
            search: new URLSearchParams(window.location.search),
            filters: filters,
            data: data.map(d => new Date(d)),
            prettify: function (ts) {
                return '€' + ts;
            },
            form: selectedFilters
        }
    },
    methods: {
        formatDate(dateString) {
            return moment(dateString, 'YYYY-MM-DD').locale(this.$i18n.locale).format('Do MMM');
        },
        clearFilter(item) {
            history.replaceState(null, null, ' ');
            var urlString = window.location.href;
            var url = new URL(urlString);
            url.searchParams.delete(item)
            VueCookies.remove(item)
            window.location.href = url;
        },
        cleardate() {
            var urlString = window.location.href;
            var url = new URL(urlString);
            url.searchParams.delete('checkin')
            url.searchParams.delete('checkout')
            VueCookies.remove('checkin')
            VueCookies.remove('checkout')
            window.location.href = url;
        },
        showFiltered() {
            var useFeatures = [];
            var proptypes = [];
            for (const item in this.form) {
                for (const value in this.form[item]) {
                    if (this.form[item][value]) {
                        if (item == 'accommodationTypes') {
                            proptypes.push(value);
                        } else {
                            useFeatures.push(value);
                        }
                    }
                }
            }

            var urlString = window.location.href;
            var url = new URL(urlString);
            url.searchParams.delete('features')
            url.searchParams.delete('proptypes')
            if (useFeatures.length) {
                url.searchParams.append('features', useFeatures.join(','));
            }
            if (proptypes.length) {
                url.searchParams.append('proptypes', proptypes.join(','));
            }
            window.location.href = url;
        }
    },
    created() {
        if (this.search.get('features') || this.search.get('proptypes')) {
            for (const item in this.form) {
                for (const value in this.form[item]) {
                    if (this.search.has('features') &&this.search.get('features').split(",").includes(value)) {
                        this.form[item][value] = true;
                    }
                    if (this.search.has('proptypes') && this.search.get('proptypes').split(",").includes(value)) {
                        this.form[item][value] = true;
                    }
                }
            }
        }
    }
}
</script>